import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'app-version-'

export default {
  path: '/app-version',
  name: 'app-version',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: 'APP版本',
      },
      component: () => import('@/views/app-version/list'),
    },
  ],
}
